import { buildTrackedRoute, resolveAppType, resolveEventTypes } from '../utils/page-hit'
import { clientPortalAnalyticsService } from '../services/clientportal-analytics.service'
import type { AnalyticsProvider } from './base.provider'

// Formats a service-selected page view into product page-hit events for the Pendo endpoint.
export class PendoAnalyticsProvider implements AnalyticsProvider {
  name = 'PendoAnalytics'

  constructor(private readonly flavor: string) {}

  track(_event: string, properties?: Record<string, unknown>): void {
    const path = (properties?.pagePath as string) ?? ''
    const locationId = properties?.locationId as string | undefined
    if (!path || !locationId) return

    const contactId = properties?.contactId as string | undefined
    const routeName = properties?.routeName as string | undefined
    const route = buildTrackedRoute(path, properties?.activeTab as string | undefined)
    const appType = resolveAppType(route, routeName, this.flavor)

    for (const eventType of resolveEventTypes(path, routeName, this.flavor === 'gokollab')) {
      clientPortalAnalyticsService.trackPageHit({ eventType, locationId, path: route, flavor: this.flavor, appType, contactId })
    }
  }
}
